<div class="radar-chart-container">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">My Top Skills</h4>
        <p class="card-subtitle">Your skill profile across all assessed traits</p>
      </div>
      <div class="card-body">
        <div class="chart-wrapper">
          <canvas #radarCanvas></canvas>
        </div>
      </div>
    </div>
  </div>